import React, { Component, PropTypes } from 'react';
import partial from 'lodash/partial';
import classnames from 'classnames';
import ModalDialog from 'common/components/modal/modal_dialog';
import StarRating from 'common/components/star_rating';
import { getVoteStats } from 'presentations/utils';
import RevisionResultsTabs from 'presentations/containers/revision_results_tabs';

export default class RevisionResults extends Component {
  constructor(props) {
    super(props);

    this.renderInPlaceComment = this.renderInPlaceComment.bind(this);
  }

  componentDidMount() {
    this.props.fetchComments();
  }

  renderInPlaceComment(comment, i) {
    const { hoveredCommentId, setHoveredComment } = this.props;
    const classes = classnames('badge badge-primary badge-md comment-pin', {
      hovered: hoveredCommentId === comment.id,
      dimmed: hoveredCommentId && hoveredCommentId !== comment.id
    });
    const imageEl = document.getElementById('revision_image');

    if (!imageEl) {
      return null;
    }

    const pinStyle = {
      top: `${(comment.percent_y * imageEl.offsetHeight)/100}px`,
      left: `${(comment.percent_x * imageEl.offsetWidth)/100}px`,
    };

    return (
      <span className={classes} key={comment.id} style={pinStyle}
          onMouseEnter={partial(setHoveredComment, comment.id)}
          onMouseLeave={partial(setHoveredComment, null)}>
        { i + 1 }
      </span>
    );
  }

  render() {
    const { toggle, presentation, inPlaceComments, children, showingComments } = this.props;
    const presentationRevision = this.props.revision;

    if (!presentationRevision) {
      return null;
    }

    const { revision } = presentationRevision;
    const { averageScore, voteCount } = getVoteStats({
      revisions: [ presentationRevision ],
      presentation
    });

    return (
      <ModalDialog modalOpen={true} closeAction={toggle} modalHeader="Entry Results"
        dialogClasses="revision-results-modal" contentClasses="wide" onPrimary={toggle}
        primaryLabel="Done">
        <div className="row align-center">
          <div className="columns small-8 large-5">
            <div className="tile read-only">
              <img src={revision.image} id="revision_image" />
              { showingComments && inPlaceComments.map(this.renderInPlaceComment) }
            </div>
            <h5 className="entry-number">entry #{presentationRevision.entry_number}</h5>
          </div>
          <div className="columns small-16 large-11">
            <div className="row presentation-stats">
              <div className="small-5">
                <span className="stat-label">Group Score</span>
                <p className="stat-value">{ averageScore }</p>
              </div>
              <div className="small-5">
                <span className="stat-label">Votes</span>
                <p className="stat-value">{ voteCount }</p>
              </div>
              <div className="small-6">
                <span className="stat-label">Your Score</span>
                <div className="stat-value">
                  <StarRating readonly={true} initialRate={revision.score}/>
                </div>
              </div>
            </div>
            <RevisionResultsTabs />
            { children }
          </div>
        </div>
      </ModalDialog>
    );
  }
}

RevisionResults.propTypes = {
  fetchComments: PropTypes.func.isRequired,
  setHoveredComment: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
  hoveredCommentId: PropTypes.number,
  presentation: PropTypes.object.isRequired,
  inPlaceComments: PropTypes.array.isRequired,
  showingComments: PropTypes.bool,
  revision: PropTypes.object,
};



// WEBPACK FOOTER //
// ./presentations/components/revision_results.jsx